import { Box, Flex, Icon, Text, Heading, Button } from '@chakra-ui/react'
import { MdPower, MdMemory, MdAdd } from 'react-icons/md'
import { useDisclosure } from '@chakra-ui/react'
import { PhysicalDeviceModal } from './modals/PhysicalDeviceModal'
import { VirtualDeviceModal } from './modals/VirtualDeviceModal'
import { DeviceDiscovery } from '../../api/types'

type Props = {
  type: 'physical' | 'virtual'
  title: string
  subtitle: string
  data?: DeviceDiscovery
}

export default function RegisterDeviceCard(props: Props) {
  const { type, title, subtitle, data } = props
  const icon = type === 'physical' ? MdPower : MdMemory
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Flex
      align="center"
      justify="space-between"
      w="full"
      p={4}
      borderBottom="1px solid"
      borderColor="gray.200"
      bg="white"
      _hover={{
        bg: 'gray.50',
      }}
    >
      <Box position="relative">
        <Box
          boxSize="48px"
          border="1px solid"
          borderColor="gray.300"
          borderRadius="2xl"
          bg="white"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Icon as={icon} boxSize={6} />
        </Box>
        {type === 'physical' && data?.count > 0 && (
          <Box
            position="absolute"
            top="-6px"
            right="-6px"
            bg="blue.500"
            color="white"
            borderRadius="full"
            fontSize="xs"
            fontWeight="bold"
            width="25px"
            height="25px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            border="2px solid white"
            lineHeight="1"
            textAlign="center"
            paddingRight="0.4"
          >
            {data?.count}
          </Box>
        )}
      </Box>
      <Box flex="1" mx={4}>
        <Heading size="sm" fontWeight="semibold">
          {title}
        </Heading>
        <Text fontSize="sm" color="gray.500">
          {subtitle}
        </Text>
      </Box>

      {data?.count > 0 && (
        <Button
          onClick={onOpen}
          size="md"
          variant="outline"
          borderRadius="md"
          px={3}
          w="44px"
          h="44px"
          borderWidth="2px"
          borderColor="blue.400"
          role="group"
          _hover={{
            bg: 'blue.400',
            borderColor: 'blue.400',
          }}
        >
          <Icon as={MdAdd} boxSize={6} color="blue.400" _groupHover={{ color: 'white' }} />
        </Button>
      )}

      {type === 'physical' ? (
        <PhysicalDeviceModal isOpen={isOpen} onClose={onClose} data={data} />
      ) : (
        <VirtualDeviceModal isOpen={isOpen} onClose={onClose} />
      )}
    </Flex>
  )
}
